import type { ComponentsOverrides, Theme } from '@mui/material'

const styleOverrides: ComponentsOverrides<Theme>['MuiPopover'] = {
  root: ({ theme }) => ({
    '& .MuiPopover-paper': {
      borderRadius: '1rem',
      border: `0.0625rem solid ${theme.palette.common.divider}`,
      boxShadow: `
              0rem 0.0625rem 0.5rem 0rem #14183300,
              0rem 0.25rem 1rem 0rem #1418331E,
              0rem 0.25rem 1.5rem 0rem #1418333B
      `,
    },
  }),
}
const MuiPopover = {
  styleOverrides,
}

export default MuiPopover
